import { useMutation, useQueryClient } from '@tanstack/react-query';

import { dismissGuide } from '../api/guide.api';
import { GUIDE_STATUS_QUERY_KEY } from '../constants/guide-query-keys';

export const useDismissGuide = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => dismissGuide(),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: GUIDE_STATUS_QUERY_KEY });
    },
  });
};
